import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCountries = (countries) => {
  return {
    type: actionTypes.SET_COUNTRIES,
    payload: countries
  }
}
